import { render, staticRenderFns } from "./ConsumerHighlights.vue?vue&type=template&id=0183163b&"
import script from "./ConsumerHighlights.vue?vue&type=script&lang=js&"
export * from "./ConsumerHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports